import { render, staticRenderFns } from "./IconDeleteAudience.vue?vue&type=template&id=4f5f1e15&"
import script from "./IconDeleteAudience.vue?vue&type=script&lang=js&"
export * from "./IconDeleteAudience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f5f1e15')) {
      api.createRecord('4f5f1e15', component.options)
    } else {
      api.reload('4f5f1e15', component.options)
    }
    module.hot.accept("./IconDeleteAudience.vue?vue&type=template&id=4f5f1e15&", function () {
      api.rerender('4f5f1e15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconDeleteAudience.vue"
export default component.exports